// Saving an alignment correction T into a scan's edits (the Align tool's "Save to scene"): the scan's
// placement becomes T · D_scan, and the Align tool's T goes back to identity, so the editor shows every
// point where it was. What the editor computed on those points (instance fits F, frame corrections W)
// stays as it is. Only a movable object's move D is re-expressed: it is published on the scan's points
// without the Align tool's T, so D' = T·D·T⁻¹ keeps the object where it was shown.
import { type Rigid, compose, inverse, isIdentity } from '../align.ts';
import type { Op, State } from './log.ts';

export type OpBody = Omit<Op, 'v' | 'parent' | 't'>;

export function realignOps(st: State, T: Rigid): OpBody[] {
  const Ti = inverse(T);
  const ops: OpBody[] = [{ op: 'tree.transform', D: { scan: compose(T, st.tree.scanD) } } as OpBody];
  for (const [obj, o] of st.objects)
    if (!isIdentity(o.D)) ops.push({ op: 'object.transform', obj, D: compose(T, compose(o.D, Ti)) } as OpBody);
  return ops;
}
